import React from 'react';
import PropTypes from 'prop-types';

class EdgeShape extends React.PureComponent {
  render() {
    const { axisValue } = this.props;
    const polylinePoints = [axisValue, -2000, axisValue, 2000];

    const stroke = 'rgb(61, 129, 164)';
    return (
      <g>
        <polyline
          points={polylinePoints.join(',')}
          style={{
            fill: 'none', stroke, strokeWidth: 5, strokeDasharray: '5',
          }}
        />
      </g>
    );
  }
}

EdgeShape.propTypes = {
  axisValue: PropTypes.number.isRequired,
};

export default EdgeShape;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/components/SeperatorLine.jsx